/* global gsap */

(function () {
  const item = document.querySelectorAll(".navbar-nav .nav-item");
  const section1 = document.getElementById("first-section");
  const sectionWithAnimations = gsap.utils.toArray(".section-with-animation h2, .section-with-animation p");
  const footerIcons = document.querySelectorAll(".icon-item");

  if (item) {
    const TL = gsap.timeline();

    TL.to(item, {
      opacity: 1,
      duration: 1,
      y: 0,
      ease: "power4",
      stagger: 0.2,
    });
  }

  if (section1) {
    gsap.to(section1, { opacity: 1, duration: 5, y: 0, ease: "power4" }, "-=0.75");
  }

  if (sectionWithAnimations) {
    sectionWithAnimations.forEach((section) => {
      gsap.to(section, {
        duration: 0.4,
        y: 0,
        opacity: 1,
        stagger: 0.1,
        scrollTrigger: {
          trigger: section,
          start: "bottom bottom",
          end: "top center",
          scrub: 1,
        },
      });
    });
  }

  if (footerIcons) {
    gsap.to(".icon-item", {
      duration: 0.2,
      y: 0,
      autoAlpha: 1,
      stagger: 0.1,
      scrollTrigger: {
        trigger: ".icon-item",
        // markers: true,
        start: "top-=99% 90%",
        end: "bottom+=50% 80%",
        scrub: 1,
      },
    });
  }
})();
